import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

import './styles/App.css';

import ContextProvider from './context/context';
import AppRouter from './routers/AppRouter';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#46146E',
        },
        secondary: {
            main: '#f50057',
        },
    },
})

function App() {
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ThemeProvider theme={theme}>
                    <ContextProvider>
                        <AppRouter />
                    </ContextProvider>
                </ThemeProvider>
            </LocalizationProvider>
        </div>
    );
}

export default App;
